const TIMER_SELECTOR = '[data-pl-timer]';
const setTimer = (timer) => {
    if(timer.totalSec > 2) {
        if(typeof window.timers === 'undefined') {
            window.timers = [];
        }
        if(typeof window.timers[timer.id] === 'undefined') {
            window.timers[timer.id] = timer;
            window.timers[timer.id].intervalId = window.setInterval(() => {
                window.timers[timer.id].totalSec -= 1;

                if(window.timers[timer.id].totalSec <= 0) {
                    window.clearInterval(window.timers[timer.id].intervalId);
                }

                $('[data-pl-timer='+timer.id+']').each(function() {
                    const mEl = $( this );
                    const id = mEl.data('plTimer');
                    const totalSec = Math.max(window.timers[id].totalSec, 0);
                    const pad = (value) => (value < 10 ? '0' : '') + value;
                    mEl.data('plTimerTotal', totalSec);
                    const dayEl = mEl.find('.timeVal.day');
                    if(dayEl.length > 0) {
                        dayEl.text(pad(Math.floor(totalSec / 86400)));
                        mEl.find('.timeVal.hour').text(pad(Math.floor((totalSec % 86400) / 3600)));
                        mEl.find('.timeVal.min').text(pad(Math.floor((totalSec % 3600) / 60)));
                        mEl.find('.timeVal.sec').text(pad(totalSec % 60));
                    } else {
                        mEl.find('.timeVal.hour').text(pad(Math.floor(totalSec / 3600)));
                        mEl.find('.timeVal.min').text(pad(Math.floor((totalSec % 3600) / 60)));
                        mEl.find('.timeVal.sec').text(pad(totalSec % 60));
                    }
                    if(totalSec <= (2 * 3600)) {
                        mEl.addClass('last2');
                    } else if(totalSec <= (4 * 3600)) {
                        mEl.addClass('last4');
                    } else if(totalSec <= (6 * 3600)) {
                        mEl.addClass('last6');
                    } else if(totalSec <= (8 * 3600)) {
                        mEl.addClass('last8');
                    }
                });
            }, 1000);
        }
    }
};

const init = () => {
    $(TIMER_SELECTOR).each(function() {
        const mEl = $( this );
        setTimer({
            id: mEl.data('plTimer'),
            totalSec: mEl.data('plTimerTotal'),
        });
    });
};

export {
    init,
}
